export default __webpack_public_path__ + "static/app-7430bfabcb1ccb6108d05cd86f292665.png";